<template>
  <form v-on:submit="submit" id="addOrgForm" novalidate>
    <div class="form-group">
      <label for="name">Name</label>
      <input v-model="orgData.name" type="text" class="form-control" id="name" placeholder="Name" />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label>Type</label>
      <v-select
        :reduce="type => type.code"
        :options="[{type: 'Employer', code: 'employer'},{type: 'Partner', code: 'partner'},{type: 'Agency', code: 'agency'}]"
        v-model="orgData.type"
        placeholder="Select Type"
        label="type"
      />
    </div>

    <button class="btn btn-primary" type="submit">Submit form</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "enrollpotentialeeform",
  data() {
    return {
      orgData: {
        name: "",
        type: ""
      }
    };
  },
  mounted() {},
  methods: {
    submit: function(event) {
      const self = this;

      const form = document.getElementById("addOrgForm");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity()) {
        const oData = this.orgData;

        const finalOrgData = {
          name: oData.name,
          type: oData.type
        };

        firebase
          .firestore()
          .collection("organizations")
          .add(finalOrgData)
          .then(() => {
            $("#editPotentialee").modal("hide");
            location.reload();
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style scoped>
</style>
